import { bindable, computedFrom } from 'aurelia-framework';
import { Key } from 'readline';

export class EditableText {
	@bindable value: string;
	@bindable change: (params: { value: string }) => void;
	@bindable cancel?: () => void;
	@bindable required = false;
	@bindable valid = true;
	@bindable editing = false;
	@bindable size = 'md';
	@bindable placeholder: string;
	@bindable labelResource: string;
	@bindable customValidate: (params: { newValue: string }) => boolean;
	@bindable editOnClick = false;

	private previousValue: string;

	startEditing(event: any) {
		this.previousValue = this.value;
		this.editing = true;

		event.stopPropagation()
		return false;
	}

	applyChanges() {
		if (!this.validate(this)) {
			this.valid = false;
			return;
		}

		this.valid = true;
		this.editing = false;

		if (this.change && this.previousValue !== this.value) {
			this.change({ value: this.value });
		}
	}

	cancelEdit() {
		this.value = this.previousValue;
		if (this.cancel) {
			this.cancel();
		}
		this.editing = false;
	}

	handleStartEditing(e: KeyboardEvent) {
		e.stopPropagation();
		if (e.code === "Space" || e.code === "Enter") {
			this.startEditing(e);
		}
	}

	handleApplyChanges(e: KeyboardEvent) {
		e.stopPropagation();
		if (e.code === "Space" || e.code === "Enter") {
			this.applyChanges();
		}
	}

	handleCancelEdit(e: KeyboardEvent) {
		e.stopPropagation();
		if (e.code === "Space" || e.code === "Enter") {
			this.cancelEdit();
		}
	}

	onInputKeyDown(event: KeyboardEvent) {
		switch (event.keyCode) {
			case 13:
				this.applyChanges();
				break;
			case 27:
				this.cancelEdit();
				break;
			default:
				return true;
		}
	}

	@computedFrom('size')
	get sizeClass() {
		switch (this.size) {
			case 'sm':
				return 'input-sm';
			case 'md':
				return '';
			case 'lg':
				return 'input-lg';
			default:
				return '';
		}
	}

	private validate(vm: EditableText) {
		const requireValidator = vm.required
			? (v: string) => !!v
			: (v: string) => true;

		return requireValidator(vm.value)
			&& (this.customValidate || (params => true))({ newValue: vm.value });
	}
}
